import React from 'react';
import styled from 'styled-components';
import { CheckboxGroup } from '@99designs/emu';
import { formatSubtext } from '../../../utils/formatSubtext';
import { ObservableField as Field, useForm } from '../../ObservableForm';
import { MultiChoiceFieldFragment } from './MultiChoiceField.generated';

export type Props = MultiChoiceFieldFragment;

export function Edit({ id: name, label, subtext, subtextLink, options, required }: Props) {
    const form = useForm();

    const optionsWithValue = options.map(({ label, value }) => {
        return {
            label,
            value: value,
        };
    });

    return (
        <Field
            form={form}
            name={name}
            title={label}
            required={required ?? false}
            message={formatSubtext(subtext, subtextLink)}
            render={() => (
                <CheckboxGroup
                    options={optionsWithValue}
                    id={name}
                    label={''}
                    {...form.attach(name)}
                />
            )}
        />
    );
}

const List = styled.ul`
    margin-bottom: 0;
`;

export function View({ multiChoiceValue: values, options }: Props) {
    return (
        <List>
            {options
                .filter((o) => values.includes(o.value))
                .map((o) => (
                    <li key={o.value}>{o.label}</li>
                ))}
        </List>
    );
}

export function HasValue({ multiChoiceValue }: Props): boolean {
    return multiChoiceValue.length !== 0;
}

export function getValue({ multiChoiceValue }: Props) {
    return multiChoiceValue;
}
